// tslint:disable:no-any

import * as React from 'react';
import { DisplayNdash } from '../components/Display';

export interface IDiveDescriptionProps {
    dive: any;
}

interface IDiveDescriptionState {
    dive: any;
}

export default class DiveDescription extends React.Component<
    IDiveDescriptionProps,
    IDiveDescriptionState
> {
    constructor(props: IDiveDescriptionProps) {
        super(props);
        this.state = {
            dive: props.dive.diveAndMixes.dive
        };
    }

    render() {
        let dive = this.state.dive;

        return (
            <div className="dive__descriptionTable">
                <div className="dive__descriptionTable__label">
                    <h3>Description:</h3>
                </div>

                <div className="dive__descriptionTable__content">
                    <span>
                        {dive.description !== '' &&
                            dive.description !== null &&
                            dive.description}
                        {(dive.description === '' ||
                            dive.description === null) && <DisplayNdash />}
                    </span>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DiveDescription.tsx